import React from 'react'
import { HashRouter, Route, RouterProvider, Routes, createBrowserRouter } from 'react-router-dom'
import './scss/style.scss'
import PrivateRoute from './views/PrivateRoute'
import { useTranslation } from 'react-i18next'
import { ToastContainer } from 'react-toastify'
import './components/style.scss'
import { initialUseTranslation } from './service/apiCall'
import SVGIconsVew from './components/IconSvg'


// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// const Profile = React.lazy(() => import('./views/pages/profile'))
// Pages
const Login = React.lazy(() => import('./views/pages/auth/login'))
const Report = React.lazy(() => import('./views/pages/Report'))
const Customers = React.lazy(() => import('./views/pages/Cutomers'))
const HomePage = React.lazy(() => import('./views/pages/HomePage'))
const InstructionPage = React.lazy(() => import('./views/pages/InstructionPage'))
const Test = React.lazy(() => import('./views/pages/TestPage'))
const Profile = React.lazy(() => import('./views/pages/Profile'))
const Instruction = React.lazy(() => import('./views/pages/Instruction'))
const CallReport = React.lazy(() => import('./views/pages/CallReport'))
const Secretary = React.lazy(() => import('./views/pages/Secretery'))
const MyQueues = React.lazy(() => import('./views/pages/MyQueues'))
const MySetting = React.lazy(() => import('./views/pages/MySetting'))
const Panel = React.lazy(() => import('./views/pages/Panel'))
const SignOut = React.lazy(() => import('./views/pages/SignOut'))
const CallWaiting = React.lazy(() => import('./views/pages/CallWaiting'))
const EditReport = React.lazy(() => import('./views/pages/Report/Edit'))

// const TempPage = React.lazy(() => import('./views/pages/tempPage'))







const App = () => {
  const { t, i18n } = useTranslation()
  initialUseTranslation(t)
  // global.roles = Roles;
  // document.body.dir = i18n.dir()
  // document.getElementsByTagName('html')[0].setAttribute("dir", i18n.dir())
  // document.documentElement.setAttribute('lang', i18n.language)
  document.body.dir = "rtl"
  document.getElementsByTagName('html')[0].setAttribute("dir", "rtl")
  document.documentElement.setAttribute('lang', "fa")
  i18n.changeLanguage('fa')



  const router = createBrowserRouter([
    {
      path: "/",
      element: <PrivateRoute />,
      children: [
        {
          path: "/",
          element: <DefaultLayout />,
          children: [
            {
              path: "/",
              element: <HomePage />
            },
            {
              path: "/profile",
              element: <Profile />
            },
            {
              path: "/editReport/:id/:callerNumber/:callReportId",
              element: <EditReport />
            },
            {
              path: '/report/:id/:customerId',
              element: <Report />
            },
            {
              path: '/instruction/:id',
              element: <InstructionPage />
            },
            {
              path: "/callWaiting",
              element: <CallWaiting />
            },
            {
              path: "/instructionLIst",
              element: <Customers />
            },
            {
              path: "/instruction",
              element: <Instruction />
            },
            {
              path: "/callReport",
              element: <CallReport />
            },
            {
              path: "/myQueues",
              element: <MyQueues />
            },
            {
              path: "/mySetting",
              element: <MySetting />
            },
            {
              path: "/panel",
              element: <Panel />
            },
            {
              path: "/secretary",
              element: <Secretary />
            },
            {
              path: "/signOut",
              element: <SignOut />
            },
            {
              path: "/util",
              element: <SVGIconsVew />
            }
          ]
        },


      ]
    },
    {
      path: "/login",
      element: <Login />
    }
  ]);

  return (
    <>
      {/* <HashRouter>
        <Routes>
          <Route exact path="login" name="Login Page" element={<Login />} />
          <Route exact path="register" name="Login Register" element={<Register />} />
          <Route exact path="temp" name="temp" element={<TempPage />} />

          <Route path="*" element={<PrivateRoute />}>
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Route>
        </Routes>
      </HashRouter> */}
      <RouterProvider router={router} />
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

    </>

  )
}

export default App
